import React from 'react';
import { View, Text, TextInput, Platform } from 'react-native';

export interface DescriptionTabProps {
  editMode: boolean;
  value: string;
  fallback?: string;
  onChange: (v: string) => void;
}

const DescriptionTab: React.FC<DescriptionTabProps> = ({ editMode, value, fallback, onChange }) => {
  return (
    <View style={{ paddingVertical: 4 }}>
      {editMode ? (
        <TextInput
          value={value}
          onChangeText={onChange}
          placeholder="輸入描述..."
          multiline
          style={{ minHeight: 96, lineHeight: 22, color: '#111827', borderWidth: 0, paddingHorizontal: 0, paddingVertical: Platform.OS === 'web' ? 6 : 4 }}
        />
      ) : (
        <Text style={{ color: '#8E8E93', lineHeight: 24, paddingLeft: 0 }}>
          {(value || fallback || '').trim().length > 0 ? (value || fallback || '') : '未提供'}
        </Text>
      )}
    </View>
  );
};

export default DescriptionTab;
